// src/pages/EnrollPage.jsx
import React from "react";
import { Box, Container, Typography } from "@mui/material";
import PageShell from "../components/layout/PageShell";
import ContactSection from "../components/shared/ContactSection";

export default function EnrollPage() {
  return (
    <PageShell>
      <Container maxWidth="sm" sx={{ py: { xs: 5, md: 8 } }}>
        <Typography sx={{ fontWeight: 800, fontSize: { xs: "1.5rem", md: "1.8rem" }, color: "#0B1530", mb: 1, textAlign: "center" }}>
          Enroll now
        </Typography>
        <Typography sx={{ fontSize: 14.5, color: "#64748B", mb: 4, textAlign: "center" }}>
          Fill out the form and our team will reach out to confirm your seat.
        </Typography>
      </Container>
      <ContactSection />
    </PageShell>
  );
}